import "../.././styles/Constitution.css";

function ArticleEleven() {
    return(
        <>
            <div className="container">
                <div className="sub-container constitution" >
                    <h3>ARTICLE XI: AMENDMENTS AND DISSOLUTION</h3>
                    <h5>11.1 Amendments and Dissolution</h5>
                    <p>
                        This Constitution and By-Laws may be amended, the name of the corporation may be changed
                        and the corporation may be dissolved by resolution of two-thirds vote of members present at a
                        General Membership Meeting.
                    </p>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution" id="section-even">
                    <h5>11.2 Proposal and Ratification of Amendments</h5>
                    <p>
                        Any proposal to amend this Constitution and By-Laws shall be approved by a majority vote of
                        the Governing Board and presented for ratification by the General Membership during the
                        General Membership Meeting or during a special meeting convened for that purpose.
                    </p>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution">
                    <h5>11.3 Asset Distribution Upon Dissolution</h5>
                    <p>
                        Upon dissolution of the corporation, after all debts and commitments have been paid, any
                        remaining assets shall not be paid to or distributed amongst members, but shall be transferred
                        by donation to one or more recognized charitable organizations in Manitoba with similar
                        objectives or mandate, as determined by a majority vote of the Governing Board.
                    </p>
                </div>
            </div>
        </>
    );
}

export default ArticleEleven;